<template>
  <div
    id="community"
    class="community-container"
  >
    <div class="team-part-wrapper content-part-wrapper community-wrapper">
      <div class="team-title-wrapper content-title-wrapper">
        <h3>{{ $t('COMMUNITY' )}}</h3>
        <span class="title-line"></span>
      </div>
      <div class="community-content-wrapper">
        <div class="bonus-community">
          <div class="community-left-wrapper">
            <div
              class="community-question"
              v-for="item in community"
            >
              <a
                target="_blank"
                class="community"
                :href="item.href"
              >
                {{item.question}}
              </a>
            </div>
          </div>
        </div>
        <div class="more-community">
          <div class="right_community">
            <div class="community_img"></div>
            <div class="get_more_community">
              <a
                target="_blank"
                href="https://bonuscloud.club/"
              >{{ $t('join') }}</a>
            </div>
          </div>
        </div>

      </div>
      <div class="community-member">
        <h3 class="community-title">{{ $t('Contributor') }}</h3>
        <div class="member-detail">
          <div class="members">
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/firstLine/gcs.jpeg"
                style=""
              >
              <div class="card-body">
                <div class="card-title">网络安全工程师</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/Better.png"
              >
              <div class="card-body">
                <div class="card-title">Betterman</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/404.jpg"
                style=""
              >
              <div class="card-body">
                <div class="card-title">404</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/firstLine/ning.png"
              >
              <div class="card-body">
                <div class="card-title">Ning</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/firstLine/tianle.jpeg"
              >
              <div class="card-body">
                <div class="card-title">天乐</div>
              </div>
            </div>
           
          </div>
          <div class="members">
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/firstLine/Hikaru.jpeg"
              >
              <div class="card-body">
                <div class="card-title">Hikaru</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/傍晚升起的太阳.jpg"
                style=""
              >
              <div class="card-body">
                <div class="card-title">傍晚升起的太阳</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/地狱天使.jpg"
                style=""
              >
              <div class="card-body">
                <div class="card-title">地狱天使</div>
              </div>
            </div>
              <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/乐.png"
                style=""
              >
              <div class="card-body">
                <div class="card-title">乐</div>
              </div>
            </div>
              <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/生为何故.jpg"
              >
              <div class="card-body">
                <div class="card-title">生为何故</div>
              </div>
            </div>

        
          </div>
          <div class="members">
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/太阳当空照.jpg"
              >
              <div class="card-body">
                <div class="card-title">太阳当空照</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/文涛.jpeg"
              >
              <div class="card-body">
                <div class="card-title">文涛</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/blown.png"
              >
              <div class="card-body">
                <div class="card-title">Blown</div>
              </div>
            </div>
            <div class="card">
              <img
                class="card-img-top"
                src="../../assets/community/secondLine/Zohar.png"
              >
              <div class="card-body">
                <div class="card-title">Zohar</div>
              </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<i18n>
{
  "en": {
    "COMMUNITY": "COMMUNITY",
    "Contributor": "BonusCloud Community Outstanding Contributor",
    "join": "JOIN BONUSCLOUD CLUB",
    "CONTENT": [
        {
          "question": "1.[Guide] ETH Wallet Binding and Verification",
          "href": "https://bonuscloud.club/viewtopic.php?f=18&t=28"
        },
        {
          "question": "2.[Activity] Get BCode with Your BxC",
          "href": "https://bonuscloud.club/viewtopic.php?f=10&t=27"
        },
        {
          "question": "3.[List of Support Devices] List of Support Devices for Merlin Plug-in",
          "href": "https://bonuscloud.club/viewtopic.php?f=19&t=58"
        },
        {
          "question": "4.[List of Support Devices] List of Support Devices for Mirror installation/ROM/custom firmwares",
          "href": "https://bonuscloud.club/viewtopic.php?f=19&t=60"
        },
        {
          "question": "5.[List of Support Devices] List of Support Devices for Openwrt Plug-ins",
          "href": "https://bonuscloud.club/viewtopic.php?f=19&t=75"
        },
        {
          "question": "6.[Raspberry Pi] Guide to Install BonusCloud for Raspberry Pi",
          "href": "https://bonuscloud.club/viewtopic.php?f=19&t=802"
        }
      ]
  },
  "zn": {
    "COMMUNITY": "社区",
    "Contributor": "BonusCloud 社区杰出贡献者",
    "join": "加入 BONUSCLOUD CLUB",
    "CONTENT": [
      {
      "question": "1.[导航]新手入门",
      "href": "https://bonuscloud.club/viewtopic.php?f=15&t=12"
      },
      {
        "question": "2.[导航]刷机资源汇总",
        "href": "https://shimo.im/docs/CrgKvjCGXVYhQ3PX"
      },
      {
        "question": "3.[工具]Windows绑定工具",
        "href": "https://bonuscloud.club/viewtopic.php?f=21&t=5233"
      },
      {
        "question": "4.[教程]提币变现教程",
        "href": "https://bonuscloud.club/viewtopic.php?f=15&t=1449"
      },
      {
        "question": "5.[教程]X86新手必看",
        "href": "https://bonuscloud.club/viewtopic.php?f=52&t=5028"
      },
      {
        "question": "6.[下载]X86镜像下载",
        "href": "https://bonuscloud.club/viewtopic.php?f=52&t=5022"
      }
    ]
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";
  
export default {
  computed: mapState({
    community() {
      return this.$t("CONTENT");
    },
    isZnWebsite: state => state.isZnWebsite,
  }),
  created() {
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.community-wrapper {
  margin-top: 170px;

  .community-content-wrapper {
    width: 80%;
    margin: 0 auto;
    display: flex;

    .community-left-wrapper {
      width: 600px;
      margin: 0 auto;
      padding: 30px;
      box-sizing: border-box;
    }

    .bonus-community {
      width: 50%;
      padding: 30px;

      .community-question {
        padding: 20px;
        width: 550px;
        margin: 0 auto;
        text-align: left;
        border-bottom: 1px solid #333;
      }

      .community-question .community {
        color: #fff;
        font-size: 14px;
        line-height: 16px;
      }

      .community-question:last-child {
        border: 0px !important;
      }
    }

    .more-community {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      .right_community {
        // display: inline-block;
        // text-align: left;
        // margin: 50px 0 0 100px;
      }

      .button {
        background-image: linear-gradient(-180deg, #15bcad 2%, #10b2cb);
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 18px;
        border-radius: 0;
        border: 0;
        display: inline-block;
        width: 90px;
        height: 30px;
        line-height: 30px;
        margin-left: 20px;
      }

      .community_img {
        background-image: url('../../assets/faq/join.png');
        background-size: cover;
        width: 150px;
        height: 150px;
        display: block;
        margin: 0 auto;
      }

      a {
        color: #fff;
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }

    .get_more_community {
      font-size: 12px;
      padding: 15px 20px;
      letter-spacing: 2px;
      border: 1px solid #fff;
      color: #fff;
      display: block;
      width: 250px;
      margin: 0 auto;
      text-align: center;
      margin-top: 30px;
    }
  }
}

@media (max-width: 720px) {
  #community {
    .community-wrapper {
      margin-top: 80px;

      .community-content-wrapper {
        width: 100%;
        display: block;

        .bonus-community {
          width: 100%;
          padding: 20px;
          box-sizing: border-box;

          .community-left-wrapper {
            width: 100%;

            .community-question {
              width: 100%;
            }
          }
        }

        .more-community {
          width: 100%;
          height: auto;
          margin: 60px 0;
        }
      }
    }
  }
}

.community-member {
  text-align: center;
  .card {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }

  .card {
    display: inline-block;
    vertical-align: top;
    width: 150px;
    margin: 20px;
    min-height: 210px;
    border: none;
    border-radius: 0;
  }


  .card-img-top {
    width: 100%;
    border-top-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: calc(0.25rem - 1px);
    border-radius: 0;
  }

  .card-body {
    padding: 5px 0;
  }

  .card-title {
    margin: 10px 0 5px;
    line-height: 1.3;
    color: #fff;
  }

  .card-text {
    margin: 5px 0;
    font-size: 0.7em;
    line-height: 1.7;
  }
  
  .community-title{
    margin-bottom: 30px;
  }
}
</style>
